import BlockedPage from '~/common/components/BlockedPage';
import { useNavFeatureFlags } from '~/common/hooks/useNavFeatureFlags';

import { StyledLoan1003LayoutContainer } from '../common/components/StyledComponents';
import { LiabilitiesCrudGrid } from './components/LiabilitiesCrudGrid';
import { LiabilitiesForm } from './components/LiabilitiesForm';
import { useLiability1003Store } from './liability1003Store';

export function Liabilities1003() {
  const includeLiability = useNavFeatureFlags().IncludeLiability;

  if (!includeLiability) {
    return <BlockedPage />;
  }

  return (
    <StyledLoan1003LayoutContainer sx={{ gap: '2rem' }}>
      <LiabilitiesCrudGrid />
      <Liabilities1003FormContainer />
    </StyledLoan1003LayoutContainer>
  );
}

function Liabilities1003FormContainer() {
  const selectedLiabilityId = useLiability1003Store(
    (s) => s.selectedLiabilityId,
  );

  if (selectedLiabilityId === null) {
    return null;
  }

  return (
    <LiabilitiesForm
      key={selectedLiabilityId}
      selectedLiabilityId={selectedLiabilityId}
    />
  );
}
